<div class="bottom-nav" [class.mobile]="showForMobile">
  @for (route of appRoutes; track route) {
    <div class="item" [class.active]="route.active"
      (click)="navigateToRoute(appRoutes,route)">
      <div class="icon">
        <mat-icon [ngClass]="route.icon" [svgIcon]="route.icon"></mat-icon>
      </div>
      <div class="text">
        <p [ngClass]="{'caption-10':showForMobile, 'subtitle-16':!showForMobile}">{{ route.title | translate }}</p>
      </div>
    </div>
  }
</div>
